import {STATE_PROP} from './global-constants'

export const getGlobal = state => state[STATE_PROP]
export const getError = state => getGlobal(state).error
export const getMyCompanyIds = state => getGlobal(state).myCompanyIds
export const getMyIndustryIds = state => getGlobal(state).myIndustryIds
